import { useState, ReactNode } from 'react';
import { Provider } from '@types';
import { TimeOfDay } from './filtersTypes';
import { FiltersContext } from './FiltersContext';

interface FiltersProviderProps {
  children: ReactNode;
}

function FiltersProvider({ children }: FiltersProviderProps) {
  const [showFilters, setShowFilters] = useState<boolean>(false);
  const [hour, setHour] = useState<number | null>(null);
  const [timeOfDay, setTimeOfDay] = useState<TimeOfDay | null>(null);
  const [provider, setProvider] = useState<Provider | null>(null);

  function resetFilters() {
    setProvider(null);
    setShowFilters(false);
    setTimeOfDay(null);
  }

  const value = {
    hour,
    provider,
    resetFilters,
    setHour,
    setProvider,
    setShowFilters,
    setTimeOfDay,
    showFilters,
    timeOfDay,
    isActive: Boolean(timeOfDay || provider || hour),
  };

  return (
    <FiltersContext.Provider value={value}>{children}</FiltersContext.Provider>
  );
}

export { FiltersProvider };
